import { Input } from "@progress/kendo-react-inputs";
import { Error } from "@progress/kendo-react-labels";

export const datasetTextField = (fieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    name,
    defaultValue,
    validator,
    onChange,
    optional,
    className,
  } = fieldRenderProps;
  const showValidationMessage = touched && validationMessage;
  const errorId = showValidationMessage ? `${id}_error` : "";

  return (
    <div className={"k-form-field-wrap"}>
      <Input
        name={name}
        label={<span>{label}</span>}
        valid={valid}
        id={id}
        value={defaultValue}
        validator={validator}
        onChange={onChange}
        optional={optional}
        className={className}
      />
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </div>
  );
};
